export default __webpack_public_path__ + "static/media/wsp.1ee748db.png";